import Auth0Lock from 'auth0-lock';
import { IEnvironment } from 'src/interfaces';
import { lang } from 'src/utils';

const auth0lockOptions = {
  allowSignUp: false,
  closable: false,
  container: 'auth0-lock-container',
  title: 'Switchboard',
  theme: {
    logo: 'https://cdn.switchboardcms.com/sb-icon-suite/v1/Coates-Logo-Colour.png',
    primaryColor: '#1686e2',
  },
  languageDictionary: {
    title: lang.welcomeBack,
    enterpriseLoginIntructions: lang.chooseLoginOption,
  },
  allowForgotPassword: false,
} as const;

let lock: Auth0LockStatic | undefined;

const attachHardRefreshOnBack = () => {
  window.addEventListener('pageshow', (event) => {
    // When coming back from SSO, browser may restore cached state
    if (event.persisted) {
      window.location.reload();
    }
  });
};

export const createSelectLockInstance = (
  environment: IEnvironment | undefined,
) => {
  if (lock || !environment?.auth0?.clientId || !environment?.auth0?.domain)
    return;

  const domain = environment?.auth0.domain || '';
  const clientId = environment?.auth0.clientId || '';
  const connection = environment?.auth0.ssoConnection || '';

  lock = new Auth0Lock(clientId, domain, {
    ...auth0lockOptions,
    allowedConnections: [connection],
    rememberLastLogin: false,
    auth: {
      redirectUrl: `${environment?.urls.mtUI}/home`,
      responseType: 'code',
      sso: false,
      params: {
        scope: 'openid profile email',
        audience: environment?.hq || '',
        prompt: 'login',
        connection,
      },
    },
  });
};

export const getLockInstance = () => lock;

export const showLoginSelectWidget = (
  environment: IEnvironment | undefined,
) => {
  createSelectLockInstance(environment);
  setTimeout(() => {
    attachHardRefreshOnBack();
    getLockInstance()?.show();
  }, 100);
};
